import React from 'react';
import ListItem, { IItemChat } from './item';

const ListChat = () => {
  const chats: IItemChat[] = [
    {
      name: 'Thầy Tiến',
      lastMessage: 'Còn cái nịt rồi bé ơi, ahuhu ....',
      icon: null,
    },
    {
      name: 'Thầy Huấn',
      lastMessage: 'Cần cù thì bù siêng năng',
      icon: null,
    },
    {
      name: 'Thầy Tiến',
      lastMessage: 'Còn cái nịt rồi bé ơi, ahuhu ....',
      icon: null,
    },
    {
      name: 'Thầy Huấn',
      lastMessage: 'Cần cù thì bù siêng năng',
      icon: null,
    },
    {
      name: 'Thầy Tiến',
      lastMessage: 'Còn cái nịt rồi bé ơi, ahuhu ....',
      icon: null,
    },
    {
      name: 'Thầy Huấn',
      lastMessage: 'Cần cù thì bù siêng năng',
      icon: null,
    },
    {
      name: 'Thầy Tiến',
      lastMessage: 'Còn cái nịt rồi bé ơi, ahuhu ....',
      icon: null,
    },
    {
      name: 'Thầy Huấn',
      lastMessage: 'Cần cù thì bù siêng năng',
      icon: null,
    },
    {
      name: 'Thầy Tiến',
      lastMessage: 'Còn cái nịt rồi bé ơi, ahuhu .... ',
      icon: null,
    },
    {
      name: 'Thầy Huấn',
      lastMessage: 'Cần cù thì bù siêng năng',
      icon: null,
    },
  ];

  return (
    <div className='list-chat-wrapper shadow'>
      <h3 className='title'>Chat</h3>
      <div className='list-chat-search'>
        <input name='' placeholder='Tìm kiếm' />
      </div>
      <div className='list-chat'>
        {chats.map((chat, idx) => (
          <ListItem chat={chat} key={idx} />
        ))}
      </div>
    </div>
  );
};

export default ListChat;
